module.exports = __webpack_public_path__ + "static/media/Rounds-07.7ef22aa9.png";